import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackHeader from '../components/BackHeader';
import NavigationBar from '../components/NavigationBar';
import BottomBanner from '../components/BottomBanner';
import { getLocalizedValue, getCurrentLanguage, LANGUAGE_CHANGE_EVENT } from '../config/languageConfig';
import { guideItems } from '../data/guides';

const GuidePage: React.FC = () => {
  const navigate = useNavigate();
  const [, setCurrentLang] = useState(getCurrentLanguage());

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLang(getCurrentLanguage());
    };

    window.addEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
    return () => {
      window.removeEventListener(LANGUAGE_CHANGE_EVENT, handleLanguageChange);
    };
  }, []);

  const handleGuideClick = (guideId: string) => {
    navigate(`/guides/${guideId}`);
    // 페이지 이동 후 상단으로 스크롤
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      <BackHeader />
      <div className="p-4 pb-20">
        <div className="space-y-4">
          {guideItems.map((guide) => (
            <div
              key={guide.id}
              className="bg-white rounded-lg overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-200"
              onClick={() => handleGuideClick(guide.id)}
            >
              <img
                src={getLocalizedValue(guide.image, {
                  en: guide.imageEn,
                  ja: guide.imageJa,
                  'zh-CN': guide.imageZhCn,
                  'zh-TW': guide.imageZhTw
                })}
                alt={getLocalizedValue(guide.title, {
                  en: guide.titleEn,
                  ja: guide.titleJa,
                  'zh-CN': guide.titleZhCn,
                  'zh-TW': guide.titleZhTw
                })}
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {getLocalizedValue(guide.title, {
                    en: guide.titleEn,
                    ja: guide.titleJa,
                    'zh-CN': guide.titleZhCn,
                    'zh-TW': guide.titleZhTw
                  })}
                </h3>
                <p className="text-gray-600 text-sm whitespace-pre-line">
                  {getLocalizedValue(guide.description, {
                    en: guide.descriptionEn,
                    ja: guide.descriptionJa,
                    'zh-CN': guide.descriptionZhCn,
                    'zh-TW': guide.descriptionZhTw
                  })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <BottomBanner />
      <NavigationBar />
    </>
  );
};

export default GuidePage;
